<template>
  <div
    class="w-full py-3 px-4 md:px-8 mt-6 border border-grey-dark rounded-lg bg-white text-main-text text-sm font-normal relative">
    <img v-if="loading_results" class="absolute fa-spin" style="left: 50%; top: 50%" src="@/assets/SVG/tail-spin-results.svg" alt="">
    <div class="flex flex-col" :class="{'results-upload': loading_results === true}">
      <div class="w-full h-full flex justify-between py-2 items-start select-none relative cursor-pointer"
           @click.stop="show_registration_toggle">
        <div class="w-full grid">
          <div class="flex items-center">
            <p class="text-brand-darker font-semibold">
              {{event.game_name}}
            </p>

            <!--              badge  dist format      -->
            <span v-if="event.distribution_format" class="text-white font-bold text-10px py-1 px-3 rounded mx-4 max-h-6 md:max-h-8 mt-5 md:mt-0"
                  :class="[event.distribution_format === 'online'?'bg-brand-light':'bg-brand-darker']" v-text="event.distribution_format"></span>
          </div>

          <div class="flex items-center md:justify-end justify-start">
            <p class="text-10px md:text-sm font-normal mt-2 md:mt-0">{{getEventDate(event.played_at)[0]}}&nbsp;<span
            >/&nbsp;{{event.place}}</span></p>
          </div>

          <div  :class="show_registration ? 'md:justify-center' : 'md:justify-end'"
                class="flex flex-row flex-1  justify-start md:text-sm text-10px mt-2">
            <p v-if="event.status === 'waiting_statistics'" class="text-brand-light font-semibold md:hidden">Игра прошла</p>
          </div>
        </div>
        <div class="absolute pin-r pin-t flex" >
          <img
              v-if="userRole === 'editor' && show_registration"
              class="my-auto w-4 h-4 md:w-auto md:h-auto flex justify-end ml-auto mr-3 cursor-pointer"
              @click.prevent.stop="delete_modal = true"
              src="@/assets/SVG/trash-bin.svg"
              alt="trash-bin"
          />
          <font-awesome-icon :icon="['far', 'angle-down']" size="2x" :class="rotateArrow" fixed-width
                             class="arrow text-additional-text cursor-pointer -mr-3"
                             @click.self.stop="show_registration = !show_registration;"></font-awesome-icon>
        </div>
      </div>
      <div v-if="show_registration" class="-mx-4 md:-mx-8">

        <div v-if="show_registration"
             class="flex justify-end md:justify-start mb-4 whitespace-no-wrap items-baseline text-10px md:text-sm max-w-64 ml-auto mr-3 md:ml-8">
          <p @click="showSortTypes" class=" font-bold md:mr-3  md:mt-6">Сортировка:</p>
          <select-box placeholder="Без сортировки" class="text-menuOrder-dark-blue md:pr-5 text-sm" id="selBox" :positionLeft="true" is_place
                      no_padding fontIsNormal hideHeading :listItems="options" v-model="selected_filter" ref="sortSelect">
          </select-box>
        </div>
        <filial-stat-list-data v-if="isFilial" ref="regData"
                        class="font-normal"
                        :event="event"
                        :number_of_events="number_of_events"
                        :registration_date="registration_date"
                        :key="uuid_stat"
                        @list_total="applications_count($event)"
                        @update="updateList"
                        @reject="reject"
                        @loading_results="loadingResults"/>
        <stat-list-data v-else ref="regData"
                        class="font-normal"
                        :event="event"
                        :number_of_events="number_of_events"
                        :registration_date="registration_date"
                        :key="uuid_stat"
                        @list_total="applications_count($event)"
                        @update="updateList"
                        @reject="reject"
                        @loading_results="loadingResults"/>
      </div>
    </div>
    <delete-modal
        key="delete_modal"
        v-if="delete_modal"
        @close="delete_modal = false"
        @yellow_button="delete_modal = false"
        @white_button="deleteGame"
        :text="'Вы уверены, что хотите удалить мероприятие?'"
        :button_text_firs="'Да'"
        :button_text_second="'Нет'"
        class="z-50 flex"
    ></delete-modal>
  </div>
</template>

<script>
import DeleteModal from '@/views/partners/events/order/delete-modal.vue';
import client from '@/clients/partners';
import cloneDeep from 'lodash/cloneDeep';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import uuid from 'uuid';
import {mapActions, mapState} from 'vuex';
import base from '@/clients/base';
import SelectBox from '@/views/partners/selectbox.vue';
import statListData from './stat-list-data.vue';
import filialStatListData from './filial-stat-list-data.vue';

export default {
  name: 'stat-list',
  components: { statListData, filialStatListData, SelectBox, DeleteModal },
  props: ['event', 'city', 'getAllEvents', 'userRole', 'number_of_events'],
  data() {
    return {
      show_registration: false,
      delete_modal: false,
      registration_date: [],
      active_ids: [],
      selected_filter: 1,
      options: {
        0: { name: 'По названию команды А-Я', value: 'name' },
        1: { name: 'По времени регистрации', value: 'time' },
      },
      applications: [],
      uuid_stat: uuid(),
      loading_results: false,
    };
  },
  watch: {
    show_registration() {
      if (this.show_registration) {
        this.getStatSeriaData();
        this.$emit('open_ref');
      } else {
        this.$emit('close_ref');
      }
    },
    '$route.query.like': {
      handler() {
        this.show_registration = !!this.$route.query.like;
      },
      deep: true,
      immediate: true,
    },
    applications() {
      const payload = {};
      payload[this.event.uuid] = this.applications;
      console.log('app', this.applications);
      if (this.registration_date.length) {
        if (this.applications.length === this.registration_date.length) {
          this.$emit('applications_update', this.applications);
          this.$emit('applications_send', payload);
        } else {
          this.$emit('applications_update_minus', this.applications);
        }
      }
    },
    registration_date() {
      if (this.registration_date && this.registration_date.length) {
        this.$emit('registations_total', this.registration_date);
      }
    },
    selected_value() {
      this.getStatSeriaData();
    },
  },
  methods: {
    ...mapActions(['selectShowModal']),
    ...mapActions(['selectModalText']),
    showSortTypes() {
      this.$refs.sortSelect.onClick();
    },
    show_registration_toggle() {
      this.show_registration = !this.show_registration;
    },
    getStatSeriaData() {
      setTimeout(() => {
        client
          .get(`/applications?city_id=${this.city}&event_day_id=${this.event.uuid}&sort=${this.selected_value}`)
          .then(({ data }) => {
            this.uuid_stat = uuid();
            this.registration_date = data.active;
          });
      }, 300);
    },
    getEventDate(date) {
      const dates = [];
      dates.push(format(date, 'DD MMMM, dd, HH:mm', { locale: ru }));
      return dates;
    },
    applications_count(data) {
      this.applications = cloneDeep(data);
      this.$emit('updateEvent');
    },
    reject() {
      this.$emit('reject');
      this.updateList();
    },
    updateList() {
      this.registration_date = [];
      this.active_ids = [];
      this.getStatSeriaData();
      this.$emit('updateEvent');
      this.selectModalText('Изменения сохранены'); this.selectShowModal(true);
    },
    loadingResults(data) {
      this.loading_results = data;
    },
    deleteGame() {
      base.delete(`/api/event-day?eventDayId=${this.event.uuid}`)
        .then(() => {
          this.$emit('updateEvent');
          this.delete_modal = false;
        });
    },
  },
  computed: {
    ...mapState({
      cityObj: state => state.auth.user.cityObj,
    }),
    modile() {
      return window.innerWidth < 840;
    },
    selected_value() {
      return this.options[this.selected_filter].value;
    },
    rotateArrow() {
      return !this.show_registration ? '' : 'rotate-arrow';
    },
    isFilial() {
      return this.cityObj ? this.cityObj.partnership_type === 'filial' && !this.event.product.toLowerCase().includes('корпоративная лига') : false;
    },
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1.5fr 1.3fr 15rem;
}

.arrow {
  transition: 0.5s all;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.copy-icon-class {
  width: 2.24rem;
  height: 2.2rem;
  border-radius: 100%;
  background-color: #e7e7e7;
}

.letter-theme {
  background-color: #BD006C;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 7px;
  padding-right: 7px;
  padding-top: 5px;
  padding-bottom: 5px;
}

@media(max-width: 840px) {
  .arrow {
    transform: scale(0.4)
  }
}

@media (max-width: 767px) {
  .hide-element {
    display: none !important;
  }

  .grid {
    display: block;
  }

  #selBox >>> .adjusting-popper {
      transform: translate(-250px, 20px) !important;
  }
}
.results-upload {
  width: 100%;
  height: 100%;
  /*position: absolute;*/
  background: white;
  opacity: 0.1;
  /*background-image: url("./src/assets/SVG/loader-results.svg");*/
}
</style>
